module.exports = __webpack_public_path__ + "static/media/famiglia.2f4c2cae.jpg";